<template>
  <div class="end-page page">
    <div class="container">
      <div class="logo"></div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/libraries/formatter';

export default {
  name: 'EndPage',

  data() {
    return {
      formatDate,
    };
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';

.end-page {
  position: relative;

  .container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8px 24px 16px;
    box-sizing: border-box;

    .logo {
      width: 512px;
      height: 256px;
      background-image: url('../../assets/CommuterLogo-Black.svg');
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
}
</style>
